import localStorageUtils from './localStorageUtils';

import * as StoreUtils from './localStorageUtils';

import * as iconUtils from './iconUtils';

export { StoreUtils, iconUtils };

export default localStorageUtils;
